import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import {endOfDay, startOfDay} from 'date-fns';

import { Table, Column, Popconfirm, Pager, DatePicker, Select } from '@smartplatform/ui';
import store from '../../store';

const PER_PAGE = 100;
const FILTER = {
	createdAt: null,
	deputyId: null,
	name: '',
	email: ''
};

@observer
export default class List extends React.Component {

	@observable records = null;
	@observable deputies = null;
	@observable users = null;
	@observable emails = null;
	@observable page = 1;
	@observable filter = FILTER;

	constructor(props) {
		super(props);
		this.getParams();
		this.init();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.match.params !== this.props.match.params) {
			// при изменении фильтров тригерится изменение роута,а за ним и инит
			this.getParams();
			this.init();
		}
	};

	@action getParams = () => {
		const { page , filter } = store.route.params  || {};
		if (page) this.page = parseInt(page);
		this.filter = FILTER;
		if (filter) {
			Object.keys(filter).forEach(key => {
				if (key === 'deputyId') this.filter[key] = parseInt(filter[key])
				else this.filter[key] = filter[key];
			})
		}
	};

	@action setParams = () => {
		if (!store.route.params) store.route.params = {};
		store.route.params.page = this.page > 1 ? this.page : undefined;
		store.route.params.filter = {};
		Object.keys(this.filter).forEach(key => {
			if (this.filter[key] && (this.filter[key] !== '-')) {
				store.route.params.filter[key] = this.filter[key]
			}
		});
		store.route.push();
	};

	init = async () => {
		const where = { and: [] };

		if (this.filter.createdAt) {
			where.and.push(
				{ createdAt: { gte: startOfDay(this.filter.createdAt) }},
				{ createdAt: { lte: endOfDay(this.filter.createdAt) }}
			)
		}
		
		if (this.filter.deputyId) {
			where.and.push({ deputyId: this.filter.deputyId });
		}

		if (this.filter.name.length > 1) {
			const names = this.filter.name.split(' ');
			where.and.push(
				{ firstName: names[1]},
				{ middleName: names[2]},
				{ lastName: names[0]}
			)
		}
		
		if (this.filter.email.length > 1) {
			where.and.push({ email: this.filter.email });
		}
		
		this.deputies = await store.model.User.find({
			fields: ['id', 'firstName', 'lastName', 'middleName', 'username', 'deputyId']
		});
		
		this.records = await store.model.Appeal.find({
			where,
			order: 'id desc',
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
			include: [
				{ relation: 'deputy' },
				{ relation: 'status' },
			]
		});
		
		const appeals = await store.model.Appeal.find();
		this.users = new Set(appeals.map((record) => `${record.lastName} ${record.firstName} ${record.middleName}`));
		this.emails = new Set(appeals.map((record) => record.email));
	};
	
	onPageChange = async page => {
		this.page = page;
		this.setParams();
	};
	
	create = () => this.props.history.push('/admin/appeals/create');
	
	fio = record => <>
		{record.lastName} {record.firstName ? <>{record.firstName.substr(0, 1)}.</> : ''} {record.middleName ? <>{record.middleName.substr(0, 1)}.</> : ''}
	</>;
	
	delete = async record => {
		await record.delete();
		this.init();
	};

	getDeputyList = (id = null) => {
		if (id) {
			const userById = this.deputies.find((user) => id === user.deputyId);
			return [userById.lastName, userById.firstName, userById.middleName].join(' ').trim() || userById.username;
		}
		return this.deputies
			.filter((u) => u.deputyId)
			.map((user) => {
				return {
					label: [user.lastName, user.firstName, user.middleName].join(' ').trim() || user.username,
					value: user.deputyId
				}
			})
	};

	setCreatedAt = (date) => {
		this.filter.createdAt = date ? new Date(date) : null;
		this.page = 1;
		this.setParams();
	};

	setDeputy = (author) => {
		this.filter.deputyId = author;
		this.page = 1;
		this.setParams();
	};

	setUser = (user) => {
		this.filter.name = user;
		this.page = 1;
		this.setParams();
	};

	setEmail = (email) => {
		this.filter.email = email;
		this.page = 1;
		this.setParams();
	};

	render() {
		if (!this.records || !this.users || !this.emails) return '...';

		return <>
			<p>Обращения граждан</p>
			{/*<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>*/}

			<div className="row">
				<div className="col-lg-2 col-md-2 col-sm-3 col-12">
					<DatePicker value={this.filter.createdAt} onChange={this.setCreatedAt} placeholder="Дата публикации" />
				</div>

				<div className="col-lg-3 col-md-3 col-sm-2 col-5">
					<Select items={this.getDeputyList()}
									onChange={this.setDeputy}
									showValue={this.filter.deputyId ? this.getDeputyList(this.filter.deputyId) : `Адресат`}
									className="drop-down-md"
					/>
				</div>

				<div className="col-lg-3 col-md-3 col-sm-2 col-5">
					<Select items={[...this.users]}
									onChange={this.setUser}
									showValue={this.filter.name.length > 1 ? this.filter.name : `Отправитель`}
									className="drop-down-md"
					/>
				</div>

				<div className="col-lg-3 col-md-3 col-sm-2 col-5">
					<Select items={[...this.emails]}
									onChange={this.setEmail}
									showValue={this.filter.email.length > 1 ? this.filter.email : `Email`}
									className="drop-down-md"
					/>
				</div>
			</div>

			<Pager
				totalCount={this.records.totalCount}
				current={this.page}
				itemsPerPage={PER_PAGE}
				onChange={this.onPageChange}
				directChange={true}
			/>
			<Table records={this.records} rootPath="/admin">
				<Column width={60} property="id" label="id" />
				<Column relation="deputy" computed={this.fio} label="Адресат" />
				<Column width={200} relation="status" property="name" label="Статус" />
				<Column computed={this.fio} label="Отправитель" />
				<Column property="email" label="E-mail" />
				<Column property="phone" label="Телефон" />
				<Column property="address" label="Адрес" />
				<Column property="createdAt" label="Дата" />
				<Column clickable={false}>
					{record => <Popconfirm content="Удалить?" onConfirm={() => this.delete(record)}>
						<a href="#" onClick={e => e.preventDefault()}>Удалить</a>
					</Popconfirm>}
				</Column>
			</Table>
		</>;
	}

}
